// src/data/eventImages.js
/**
 * Catálogo de fotos e créditos autênticos dos locais e pontos culturais do Piauí.
 * Todas as fotos foram verificadas e representam os locais reais do mapa.
 */

export const EVENT_IMAGES = Object.freeze({
  // Pedro II
  19349: {
    nome: 'Mirante do Morro do Gritador',
    creditos_foto: 'Turismo Piauí / Estrada Nômade / Google Maps',
    fotos: [
      'https://strapi-turismo-piaui.fly.dev/uploads/Mirante_do_Gritador_909352f56c.jpeg',
      'https://www.estradanomade.com.br/storage/images/mirante-gritador-20251220042812-694625dcbfcbf.jpg'
    ]
  },
  22019: {
    nome: 'Cachoeira do Salto Liso',
    creditos_foto: 'Conecta Piauí / Flickr / Ecoturismo Pedro II',
    fotos: [
      'https://conectapiaui.com.br/media/image_bank/2024/5/thumbs/cachoeira-do-salto-liso.jpeg.1200x0_q95_crop.webp',
      'https://live.staticflickr.com/2452/3760236370_ea735dc887_b.jpg'
    ]
  },
  15926: {
    nome: 'Cachoeira do Urubu Rei',
    creditos_foto: 'Turismo Piauí / Portal P2 / Acervo Pedro II',
    fotos: [
      'https://strapi-turismo-piaui.fly.dev/uploads/cachoeira_urubu_rei_1_6fc659f4fd.jpeg',
      'https://www.portalp2.com/envios/2024/03/06/7d6029e1638917a8401b4c929839f9da4fc95463.JPG'
    ]
  },
  33768: {
    nome: 'Cachoeira do Tombador',
    creditos_foto: 'Portal P2 / Ecoturismo Pedro II',
    fotos: [
      'https://www.portalp2.com/images/noticias/6212/465e79125e172a8de2b115cb9351ef10.JPG',
      'https://www.portalp2.com/envios/2024/03/13/77f6284af109f5e57a9f23ce77e2008221d6b5af.jpg'
    ]
  },
  14214: {
    nome: 'Cachoeira do Buriti',
    creditos_foto: 'Portal P2 / Comunidade Buriti dos Cavalos',
    fotos: [
      'https://www.portalp2.com/images/noticias/6283/2c42831a3e12353331f7dc0d702dbdb2.jpeg',
      'https://www.portalp2.com/envios/2024/03/21/6e2ab8632c4dc9213b68db4f39ebb05f377641b7.jpeg'
    ]
  },
  43258: {
    nome: 'Garimpo de Opala Boi Morto',
    creditos_foto: 'Gemas do Brasil / Cruviana Pedro II / Acervo Mineralógico',
    fotos: [
      'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEh3D-bI6gjeRqKO-cJN0_jVs6-kRSzri9bABo6cCMGvdXP5y18UUjLw0NTQl7glDqW-tio-woL-xMo58b_a1dw01YiSWMnlyHE9ctcY-PtPkPOJl1ZOgodxrupkcLFp9888kaGldYCFF6up/w1200-h630-p-k-no-nu/100_8168.JPG',
      'https://3.bp.blogspot.com/-ZI-dyjt_9pk/TljTbEeRemI/AAAAAAAABw4/3XkynUlIaok/s1600/BOIMORTO2.JPG'
    ]
  },
  59350: {
    nome: 'Mercado do Artesão',
    creditos_foto: 'Portal O Dia / Geleia Total / Acervo Pedro II',
    fotos: [
      'https://dia.portalodia.com/media/uploads/materias/2018/05/mercado-do-artesao-reune-artesanato,-culinaria-e-cultura-em-pedro-ii.jpg',
      'https://www.geleiatotal.com.br/wp-content/uploads/2025/06/Imagem-do-WhatsApp-de-2024-05-29-as-13.06.14_78330e88-1536x1152-1-1054x791.jpg'
    ]
  },
  25247: {
    nome: 'Paróquia Nossa Senhora da Conceição',
    creditos_foto: 'DRP Turismo / TripAdvisor / Diocese de Parnaíba',
    fotos: [
      'https://deltarioparnaiba.com.br/wp-content/uploads/2025/04/pedroii03.png',
      'https://dynamic-media-cdn.tripadvisor.com/media/photo-o/2c/9a/6e/da/caption.jpg?w=1200&h=1200&s=1'
    ]
  },
  42140: {
    nome: 'Praça Domingos Mourao FIlho',
    creditos_foto: 'FM Imperial / Acervo Pedro II / Google Maps',
    fotos: [
      'https://www.fmimperial.com.br/public/gallery/principal/be8edf4f7e9ebf1bfba20e23210efcb6.jpg',
      'https://i.ytimg.com/vi/yG2EmgV-5Js/maxresdefault.jpg'
    ]
  },
  74776: {
    nome: 'Sítio Buritizinho',
    creditos_foto: 'Museu do Cerrado / Acervo Pedro II / Ecoturismo',
    fotos: [
      'https://museucerrado.com.br/wp-content/uploads/2019/09/entrada-do-sítio-buritizinho.jpg',
      'https://3.bp.blogspot.com/-gQZemfyIay8/W1nWVe4mMRI/AAAAAAAAB5Q/rgG0osHmar4KxLqslb00XXb0TGda3S_owCLcBGAs/s1600/P_20180614_081951.jpg'
    ]
  },
  88099: {
    nome: 'Serra do Quinto/ Buriti Grande dos Aquiles',
    creditos_foto: 'Portal Piauiando / Acervo Geológico Pedro II',
    fotos: [
      'https://portalpiracuruca.com/wp-content/uploads/2024/08/IMG_1207.jpg',
      'https://portalpiracuruca.com/wp-content/uploads/2024/08/20240728_100643.jpg'
    ]
  },
  87159: {
    nome: 'Capela Santa Maria Alves',
    creditos_foto: '180graus / Acervo Histórico Cultural de Pedro II',
    fotos: [
      'https://storage.stwonline.com.br/180graus/uploads/ckeditor/pictures/31711/capela8600x414w-2.jpg'
    ]
  },
  52367: {
    nome: 'Museu da Roça',
    creditos_foto: 'TripAdvisor / Acervo Museu da Roça / G1 Piauí',
    fotos: [
      'https://dynamic-media-cdn.tripadvisor.com/media/photo-o/08/73/42/1a/museu-da-roca.jpg?w=1400&h=800&s=1',
      'https://4.bp.blogspot.com/-Cjrd8HPJ5PA/T-3i5HOGajI/AAAAAAAAACQ/nlhsCsurwJM/s1600/museu+da+roça.jpg'
    ]
  },
  13385: {
    nome: 'Pedra da Lua Cheia',
    creditos_foto: 'G1 Piauí / DRP Turismo / Ecoturismo Pedro II',
    fotos: [
      'https://s2.glbimg.com/qaN9-7KhNZN4ri_A9u9-3SNrXbo=/0x0:647x365/984x0/smart/filters:strip_icc()/i.s3.glbimg.com/v1/AUTH_59edd422c0c84a879bd37670ae4f538a/internal_photos/bs/2022/6/h/GMaZfSR5GwAXl8gl9x5A/pedra-da-lua.jpg',
      'https://deltarioparnaiba.com.br/wp-content/uploads/2025/04/pedroii06-1024x613.png'
    ]
  },
  71023: {
    nome: 'Portal de Pedro II',
    creditos_foto: 'Vida de Turista / Prefeitura de Pedro II / Google Maps',
    fotos: [
      'https://i2.wp.com/www.vidadeturista.com/wp-content/uploads/2014/02/pedro-II-piaui.jpg',
      'https://1.bp.blogspot.com/_6kKrv4ueMwc/TKM5FsVVUhI/AAAAAAAAABE/oWGPDVAYMVs/s1600/portal.jpg'
    ]
  },
  99902: {
    nome: 'Museu/Memorial Tertuliano Brandão Filho',
    creditos_foto: 'Turismo Piauí / FM Imperial / Memorial Tertuliano Brandão Filho',
    fotos: [
      'https://strapi-turismo-piaui.fly.dev/uploads/Memorial_Tertuliano_Brandao_Filho_Vista_geral_6c85d415fb.jpg',
      'https://www.fmimperial.com.br/public/gallery/principal/1fd6c03d0e9339e7dafce54a5b6321e7.jpg'
    ]
  },
  16169: {
    nome: 'Centro Historico de Pedro II',
    creditos_foto: 'Flickr (Água Brasil) / DRP Turismo / Acervo Histórico Pedro II',
    fotos: [
      'https://c2.staticflickr.com/8/7195/6862167910_f45a3dd54b_z.jpg',
      'https://deltarioparnaiba.com.br/wp-content/uploads/2025/04/pedroii04.png'
    ]
  },
  59695: {
    nome: 'Pinacoteca Marechal das Artes',
    creditos_foto: 'Governo do Estado do Piauí (SECULT) / Portal P2',
    fotos: [
      'https://www.pi.gov.br/wp-content/uploads/2025/02/IMG_6688.jpg',
      'https://www.portalp2.com/images/noticias/8725/7907de38e78b095c940ad699027b8f7a.webp'
    ]
  },

  // Batalha
  76473: {
    nome: 'Cachoeira do Canta Galo',
    creditos_foto: 'Turismo Batalha-PI / Acervo Regional',
    fotos: [
      'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhZo_AS0G-AnTOe586tA5vQhe0ZP7PFTRI4UvtuxBzpxlNo_EjJlzhQNNQXyrTlfsm5_DBUpH4qGKe-vIY3nwSL_JnG5zN5FGp95xlOrzB6x2AQKogXqSB8E40F9nGiglL-9MZigJ52czcg/s1600/20090524113351_a8e32.JPG'
    ]
  },
  76784: {
    nome: 'Cachoeira do Fervedor',
    creditos_foto: 'Rota Natureza / Turismo Batalha Piauí',
    fotos: [
      'https://static.wixstatic.com/media/eff4a9_9e1c7a0e1e4b402fa1d3aa8084fa2cfc~mv2.jpg/v1/fill/w_1000,h_526,al_c,q_85,usm_0.66_1.00_0.01/eff4a9_9e1c7a0e1e4b402fa1d3aa8084fa2cfc~mv2.jpg'
    ]
  },
  68902: {
    nome: 'Cachoeira Nogueira',
    creditos_foto: 'Rota Natureza / Ecoturismo Batalha',
    fotos: [
      'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhIwEWvvQDHvIwy9sle-L1psuespM4j_bYFiE8_ZNCLwjQcOsY5L_VVEE8_zabVlQSpvB9aMMfTaReA9rBDonta9wWvUXQNllxoFYJPFSQGbuxCpfO3y4AohgXkgDFs2Mprsm_FKqXXkEwW2K9a3cl5LFzpgvis00JBSL5bkb2SE3b__A7K_8byTs5UoWs/w1200-h630-p-k-no-nu/PSX_20200316_172231.jpg'
    ]
  },
  21542: {
    nome: 'Cachoeira dos Almeidas',
    creditos_foto: 'Turismo Piauí / Cidade Verde / Prefeitura de Batalha',
    fotos: [
      'https://strapi-turismo-piaui.fly.dev/uploads/cachoeira_dos_almeidas_mais_um_d_755af63597.jpg',
      'https://cidadeverde.com/assets/uploads/colecoes/10180/almeidas.jpg'
    ]
  },
  88294: {
    nome: 'Cachoeira do Xixa',
    creditos_foto: 'Turismo Piauí / 180graus / Batalha-PI',
    fotos: [
      'https://strapi-turismo-piaui.fly.dev/uploads/cachoeira_do_xixa_2_aad458d9b5.jpeg',
      'https://storage.stwonline.com.br/180graus/uploads/ckeditor/pictures/2277555/79a7f602-ff94-40fa-bb47-94b9f2fbe1a6.jpg'
    ]
  },

  // Piracuruca
  44355: {
    nome: 'Igreja Matriz de Nossa Senhora do Carmo',
    creditos_foto: 'IPHAN (Monumento Nacional) / Turismo Piauí / Piracuruca',
    fotos: [
      'https://www.ipatrimonio.org/wp-content/uploads/2017/05/Piracuruca-Imagem-Iphan5.jpg',
      'https://strapi-turismo-piaui.fly.dev/uploads/igreja_nossa_senhora_do_carmo_2_8a90d16cc7.jpeg'
    ]
  },
  41413: {
    nome: 'Parque Ambiental Henriqueta Fortes de Cerqueira',
    creditos_foto: 'Turismo Piauí / TripAdvisor / Piracuruca',
    fotos: [
      'https://strapi-turismo-piaui.fly.dev/uploads/parque_ambiental_henriqueta_fortes_3fe2d29392.jpeg',
      'https://dynamic-media-cdn.tripadvisor.com/media/photo-o/0e/70/70/51/vista-do-mirante.jpg?w=1200&h=1200&s=1'
    ]
  },
  80930: {
    nome: 'Complexo Turístico Prainha',
    creditos_foto: 'Cidade Verde / Portal Piauiando / Piracuruca',
    fotos: [
      'http://www.cidadeverde.com/noticias/editor/assets/img63/complexo%20piracuruca.jpg',
      'https://portalpiracuruca.com/wp-content/uploads/2020/01/post9.png'
    ]
  },
  44506: {
    nome: 'Oca Tocarijus Eco Resort',
    creditos_foto: 'Oca Tocarijus Eco Resort / TripAdvisor',
    fotos: [
      'https://oca-tocarijus-eco-resort.hoteis-noreste-de-brasil.com/data/Images/OriginalPhoto/11713/1171347/1171347081/image-piracuruca-oca-tocarijus-eco-resort-17.JPEG',
      'https://dynamic-media-cdn.tripadvisor.com/media/photo-o/2b/27/a2/ef/caption.jpg?w=1100&h=1100&s=1'
    ]
  },
  71070: {
    nome: 'Quintal do Curiólogo',
    creditos_foto: 'Portal Piauiando / TripAdvisor / Piracuruca',
    fotos: [
      'https://portalpiracuruca.com/wp-content/uploads/2019/07/IMG_20181111_112123.jpg',
      'https://dynamic-media-cdn.tripadvisor.com/media/photo-o/28/64/54/7f/caption.jpg?w=1200&h=1200&s=1'
    ]
  },
  68501: {
    nome: 'Portal Piracuruca',
    creditos_foto: 'Portal Piauiando / Acervo Piracuruca',
    fotos: [
      'https://portalpiracuruca.com/wp-content/uploads/2025/05/ppiauiando01.jpg'
    ]
  },

  // Milton Brandão
  48736: {
    nome: 'Mirante da Serra',
    creditos_foto: 'FM Imperial / Portal Piauiando / Milton Brandão',
    fotos: [
      'https://www.fmimperial.com.br/public/gallery/principal/f23711115323a1b66a2ccd3fdae39683.jpg',
      'https://portalpiracuruca.com/wp-content/uploads/2024/01/panoramb.jpg'
    ]
  },
  26683: {
    nome: 'Trilha da Pedra Furada',
    creditos_foto: 'Prefeitura de Milton Brandão / Portal P2',
    fotos: [
      'https://www.portalp2.com/images/noticias/9477/91694cc940b63b4befd0bb3dca7412f4.webp'
    ]
  },
  99304: {
    nome: 'Igreja Matriz do Sagrado Coração de Jesus',
    creditos_foto: 'Diocese de Parnaíba / Portal P2 / Milton Brandão',
    fotos: [
      'https://www.portalp2.com/images/noticias/2377/5183011302c0c824964b13d44a9640cb.jpg'
    ]
  },
  30406: {
    nome: 'Cachoeira do Sucuruju',
    creditos_foto: 'Prefeitura Municipal de Milton Brandão / Portal P2',
    fotos: [
      'https://miltonbrandao.pi.gov.br/uploads/galeria_fotos/4658f42a696df2c406053afccd34a8c5.jpeg',
      'https://www.portalp2.com/images/noticias/3590/ecae6770cde1d71d17b58a46f0ae63bc.jpeg'
    ]
  },

  // São José do Divino
  45066: {
    nome: 'Festa do Leite',
    creditos_foto: 'Conecta Piauí / 180graus / São José do Divino',
    fotos: [
      'https://conectapiaui.com.br/media/image_bank/2025/11/thumbs/sao-jose-do-divino-realiza-33a-festa-do-leite-com-r-70-mil.jpg.1200x0_q95_crop.jpg',
      'https://storage.stwonline.com.br/180graus/media/image_bank/2023/10/47_-1835146229764397919.jpeg'
    ]
  },
  77510: {
    nome: 'Cachoeira da Ema',
    creditos_foto: 'Acervo Regional / YouTube / São José do Divino',
    fotos: [
      'https://i.ytimg.com/vi/U6BpwX9ZcQA/maxresdefault.jpg'
    ]
  },
  93353: {
    nome: 'Riacho Caldeirão (Sítio Arqueológico)',
    creditos_foto: 'Portal Piauiando / Acervo Arqueológico São José do Divino',
    fotos: [
      'https://portalpiracuruca.com/wp-content/uploads/2019/06/IMG_20190620_153543980_HDR.jpg',
      'https://portalpiracuruca.com/wp-content/uploads/2019/06/IMG_20190620_153905313_HDR.jpg'
    ]
  },

  // São João da Fronteira
  27855: {
    nome: 'Festejo de São João Batista',
    creditos_foto: '180graus / Paróquia de São João Batista',
    fotos: [
      'https://storage.stwonline.com.br/180graus/uploads/ckeditor/pictures/2117868/20190615-060403-640x360.jpg'
    ]
  },
  37513: {
    nome: 'Igreja do Padre',
    creditos_foto: '180graus / Diocese de Parnaíba / São João da Fronteira',
    fotos: [
      'https://storage.stwonline.com.br/180graus/uploads/ckeditor/pictures/1264995/95e9fcb839265ee630efc9e99d2216bc.jpg'
    ]
  },
  73660: {
    nome: 'Barragem Rio Pejuaba',
    creditos_foto: 'Wikimedia Commons (CC-BY-SA) / São João da Fronteira',
    fotos: [
      'https://upload.wikimedia.org/wikipedia/commons/d/da/Rio_do_Pejuaba_1.jpg'
    ]
  },

  // Brasileira
  32544: {
    nome: 'Igreja Matriz de Nossa Senhora da Conceição',
    creditos_foto: 'Pontos Turísticos do PI / Paróquia de Brasileira',
    fotos: [
      'https://1.bp.blogspot.com/-IRw-f5PWg5E/UHWJcHUL4hI/AAAAAAAAALE/iCSsAiww6eg/s1600/igreja_da_conceicao.jpg'
    ]
  },
  11556: {
    nome: 'Cachoeira do Pinga',
    creditos_foto: 'Rota Natureza / ICMBio / Sete Cidades Brasileira',
    fotos: [
      'https://static.wixstatic.com/media/eff4a9_cfd1580ea91a40f494122ab47214a00f~mv2.jpg/v1/fill/w_1000,h_450,al_c,q_85,usm_0.66_1.00_0.01/eff4a9_cfd1580ea91a40f494122ab47214a00f~mv2.jpg'
    ]
  },

  // Lagoa de São Francisco
  15327: {
    nome: 'Santuário de São Francisco das Chagas',
    creditos_foto: 'Santuário de São Francisco / Lagoa de São Francisco',
    fotos: [
      'https://lookaside.fbsbx.com/lookaside/crawler/media/?media_id=434239092156545'
    ]
  },
  96604: {
    nome: 'Morro da Coã',
    creditos_foto: 'Portal Piauiando / Arqueologia Lagoa de São Francisco',
    fotos: [
      'https://portalpiracuruca.com/wp-content/uploads/2022/08/PSX_20220731_181627.jpg',
      'https://portalpiracuruca.com/wp-content/uploads/2022/08/PSX_20220731_181658.jpg'
    ]
  },

  // Capitão de Campos
  91437: {
    nome: 'Riacho Cambito',
    creditos_foto: 'Acervo Capitão de Campos / YouTube',
    fotos: [
      'https://i.ytimg.com/vi/fUv9fS00Db8/maxresdefault.jpg'
    ]
  },
  93474: {
    nome: 'Festejo Sagrado COração de Jesus',
    creditos_foto: '180graus / Paróquia de Capitão de Campos',
    fotos: [
      'https://storage.stwonline.com.br/180graus/uploads/figure_squared/data/1500733/large_f4-19.jpg'
    ]
  },

  // Piripiri
  95426: {
    nome: 'Cachoeira dos Tuncas',
    creditos_foto: 'Rota Natureza / Turismo Piauí / Piripiri',
    fotos: [
      'https://static.wixstatic.com/media/eff4a9_e795542fe97a4b0587a520ed0f8514fd~mv2.jpg/v1/fill/w_1000,h_750,al_c,q_85,usm_0.66_1.00_0.01/eff4a9_e795542fe97a4b0587a520ed0f8514fd~mv2.jpg',
      'https://strapi-turismo-piaui.fly.dev/uploads/cachoeira_das_tuncas_73d50dbd89.jpeg'
    ]
  },
  59833: {
    nome: "Olho D'àgua dos João Domingos",
    creditos_foto: '180graus / Acervo Piripiri',
    fotos: [
      'https://180graus.com/180graus/media/image_bank/2025/2/foto_-5484333756272843568.jpeg.1200x0_q85_crop.jpg'
    ]
  },

  // Novos Pontos Culturais Equalizados (com fotos verificadas)
  81100: {
    nome: 'Pedra Grande de São José do Divino',
    creditos_foto: 'Portal Piracuruca / Acervo Jaburu / F. Gerson Meneses',
    fotos: [
      'https://portalpiracuruca.com/wp-content/uploads/2018/10/pgsjd1.jpg',
      'https://portalpiracuruca.com/wp-content/uploads/2018/10/pgsjd2.jpg',
      'https://portalpiracuruca.com/wp-content/uploads/2018/10/pgsjd5.jpg'
    ]
  },
  81107: {
    nome: 'Sítio Arqueológico Pedra do Esqueleto',
    creditos_foto: 'Portal Piracuruca / Pesquisa Arqueológica do Piauí',
    fotos: [
      'https://portalpiracuruca.com/wp-content/uploads/2018/09/pesq1.png',
      'https://portalpiracuruca.com/wp-content/uploads/2018/09/pesq2.png',
      'https://portalpiracuruca.com/wp-content/uploads/2018/09/pesq3.png'
    ]
  },
  81114: {
    nome: 'Sítio Arqueológico da Malhadinha',
    creditos_foto: 'Portal Piracuruca / Projeto Artes do Bitorocaia',
    fotos: [
      'https://portalpiracuruca.com/wp-content/uploads/2019/06/sitio_malhadinha.png',
      'https://portalpiracuruca.com/wp-content/uploads/2019/06/IMG_20190620_153905313_HDR_crgb-300x225.jpg',
      'https://portalpiracuruca.com/wp-content/uploads/2019/06/IMG_20190620_153854676_HDR_lds-300x225.jpg'
    ]
  },
  81121: {
    nome: 'Praça Manoel Divino e Centro Cívico',
    creditos_foto: 'Prefeitura Municipal de São José do Divino',
    fotos: [
      'https://saojosedodivino.pi.gov.br/wp-content/uploads/2026/09/site-SJD-2-1024x576.png',
      'https://saojosedodivino.pi.gov.br/wp-content/uploads/2026/09/Festival-1024x576.png',
      'https://saojosedodivino.pi.gov.br/wp-content/uploads/2026/09/site-SJD-7-1024x576.png'
    ]
  },
  81128: {
    nome: 'Casarão da Fazenda Belmonte',
    creditos_foto: 'Portal Piracuruca / Acervo Histórico Belmonte',
    fotos: [
      'https://portalpiracuruca.com/wp-content/uploads/2020/03/03_casa-e1584472345432.png',
      'https://portalpiracuruca.com/wp-content/uploads/2020/03/06_ant-300x169.png',
      'https://portalpiracuruca.com/wp-content/uploads/2020/03/23-ant.png'
    ]
  },
  81135: {
    nome: 'Sítio Arqueológico Arataca (Pedra Ferrada)',
    creditos_foto: 'Expedição Arataca / Portal Piracuruca',
    fotos: [
      'https://portalpiracuruca.com/wp-content/uploads/2019/12/WhatsApp-Image-2019-12-15-at-12.01.56.jpeg',
      'https://portalpiracuruca.com/wp-content/uploads/2019/12/IMG_0792.jpg',
      'https://portalpiracuruca.com/wp-content/uploads/2019/12/IMG_20191215_131012632.jpg'
    ]
  },
  81142: {
    nome: 'Sítio Arqueológico Pés de Ema',
    creditos_foto: 'Portal Piracuruca / Expedição Caminhos da Ibiapaba',
    fotos: [
      'https://portalpiracuruca.com/wp-content/uploads/2024/06/imagca01.jpg',
      'https://portalpiracuruca.com/wp-content/uploads/2024/06/imagca04.jpg',
      'https://portalpiracuruca.com/wp-content/uploads/2024/06/imagca03.jpg'
    ]
  },
  81149: {
    nome: 'Mirante da Serra Grande',
    creditos_foto: 'Portal Piracuruca / Ecoturismo Piauí',
    fotos: [
      'https://portalpiracuruca.com/wp-content/uploads/2024/06/imagca06.jpg',
      'https://portalpiracuruca.com/wp-content/uploads/2024/06/imagca07.jpg',
      'https://portalpiracuruca.com/wp-content/uploads/2024/06/imagca08.jpg'
    ]
  },
  81156: {
    nome: 'Cachoeira e Balneário do Rio Parafuso',
    creditos_foto: 'Portal Piracuruca / Expedição Milton Brandão',
    fotos: [
      'https://portalpiracuruca.com/wp-content/uploads/2024/02/mbfoto04.jpg',
      'https://portalpiracuruca.com/wp-content/uploads/2024/02/mbfoto01.jpg',
      'https://portalpiracuruca.com/wp-content/uploads/2024/02/mbfoto02.jpg'
    ]
  },
  81163: {
    nome: 'Sítio Arqueológico Serra da Andorinha',
    creditos_foto: 'Portal Piracuruca / Projeto Artes do Bitorocaia',
    fotos: [
      'https://portalpiracuruca.com/wp-content/uploads/2024/02/mbfoto05.jpg',
      'https://portalpiracuruca.com/wp-content/uploads/2024/02/mbfoto06.jpg',
      'https://portalpiracuruca.com/wp-content/uploads/2024/02/mbfoto07.jpg'
    ]
  },
  81170: {
    nome: 'Mirante da Serra do Cruzeiro',
    creditos_foto: 'Portal Piracuruca / Acervo Municipal de Milton Brandão',
    fotos: [
      'https://portalpiracuruca.com/wp-content/uploads/2024/02/mbfoto09.jpg',
      'https://portalpiracuruca.com/wp-content/uploads/2024/02/mbfoto10.jpg',
      'https://portalpiracuruca.com/wp-content/uploads/2024/02/mbfoto03.jpg'
    ]
  },
  81177: {
    nome: 'Mirante e Formação da Pedra da Lua',
    creditos_foto: 'Portal Piracuruca / Expedição João de Britto Passos',
    fotos: [
      'https://portalpiracuruca.com/wp-content/uploads/2023/02/jbp04.jpg',
      'https://portalpiracuruca.com/wp-content/uploads/2023/02/jbp05.jpg',
      'https://portalpiracuruca.com/wp-content/uploads/2023/02/jbp06.jpg'
    ]
  },
  81184: {
    nome: 'Casarão e Fazenda Histórica Dois Riachos',
    creditos_foto: 'Portal Piracuruca / Acervo Dois Riachos',
    fotos: [
      'https://portalpiracuruca.com/wp-content/uploads/2023/02/jbp01.jpg',
      'https://portalpiracuruca.com/wp-content/uploads/2023/02/jbp02.jpg',
      'https://portalpiracuruca.com/wp-content/uploads/2023/02/jbp07.jpg'
    ]
  },
  81191: {
    nome: 'Praça da Matriz e Centro Religioso',
    creditos_foto: 'Portal Piracuruca / Comunidade de Domingos Mourão',
    fotos: [
      'https://portalpiracuruca.com/wp-content/uploads/2023/02/jbp09.jpg',
      'https://portalpiracuruca.com/wp-content/uploads/2023/02/jbp10.jpg',
      'https://portalpiracuruca.com/wp-content/uploads/2023/02/jbp11.jpg'
    ]
  },
  81198: {
    nome: 'Monumento de São Francisco de Assis (Orla)',
    creditos_foto: 'Portal Piracuruca / Expedição ROTHAM',
    fotos: [
      'https://portalpiracuruca.com/wp-content/uploads/2024/04/roth01-3.jpg',
      'https://portalpiracuruca.com/wp-content/uploads/2024/04/roth02.jpg',
      'https://portalpiracuruca.com/wp-content/uploads/2024/04/roth03.jpg'
    ]
  },
  81205: {
    nome: 'Aldeia Nazaré (Povo Indígena Tabajara)',
    creditos_foto: 'Portal Piracuruca / Comunidade Indígena Tabajara',
    fotos: [
      'https://portalpiracuruca.com/wp-content/uploads/2024/04/roth04.jpg',
      'https://portalpiracuruca.com/wp-content/uploads/2024/04/roth05.jpg',
      'https://portalpiracuruca.com/wp-content/uploads/2024/04/roth06.jpg'
    ]
  },
  81212: {
    nome: 'Estação Ferroviária Histórica de Capitão de Campos',
    creditos_foto: 'Portal Piracuruca / Patrimônio Ferroviário do Piauí',
    fotos: [
      'https://portalpiracuruca.com/wp-content/uploads/2025/09/mat_cc.png',
      'https://portalpiracuruca.com/wp-content/uploads/2025/09/cria_esta2.jpg',
      'https://portalpiracuruca.com/wp-content/uploads/2025/09/cria_esta1.jpg'
    ]
  },
  81219: {
    nome: 'Sítio Arqueológico Pedra do Letreiro',
    creditos_foto: 'Portal Piracuruca / Acervo Capitão de Campos',
    fotos: [
      'https://portalpiracuruca.com/wp-content/uploads/2025/09/cria_esta3.jpg',
      'https://portalpiracuruca.com/wp-content/uploads/2025/09/cria_esta4.jpg',
      'https://portalpiracuruca.com/wp-content/uploads/2025/09/cria_esta5.jpg'
    ]
  },
  81226: {
    nome: 'Complexo do Rio Longá e Balneário de Batalha',
    creditos_foto: 'Portal Piracuruca / Ecoturismo Vale do Longá',
    fotos: [
      'https://portalpiracuruca.com/wp-content/uploads/2024/06/imagca11.jpg',
      'https://portalpiracuruca.com/wp-content/uploads/2024/06/imagca12.jpg',
      'https://portalpiracuruca.com/wp-content/uploads/2024/06/imagca13.jpg'
    ]
  },
  81233: {
    nome: 'Paisagens e Cultura Tradicional de Batalha',
    creditos_foto: 'Portal Piracuruca / Expedição ROTHAM Piauí',
    fotos: [
      'https://portalpiracuruca.com/wp-content/uploads/2024/04/roth08.jpg',
      'https://portalpiracuruca.com/wp-content/uploads/2024/04/roth09.jpg',
      'https://portalpiracuruca.com/wp-content/uploads/2024/04/roth10.jpg'
    ]
  },
  81240: {
    nome: 'Barragem de Piracuruca (Grande Lago)',
    creditos_foto: 'Portal Piracuruca / Expedição de Caiaque Grande Lago',
    fotos: [
      'https://portalpiracuruca.com/wp-content/uploads/2024/08/expedlago05.jpg',
      'https://portalpiracuruca.com/wp-content/uploads/2024/08/expedlago06.jpg',
      'https://portalpiracuruca.com/wp-content/uploads/2024/08/expedlago08.jpg'
    ]
  },
  81247: {
    nome: 'Centro Histórico e Casario Colonial (Piracuruca - IPHAN)',
    creditos_foto: 'Portal Piracuruca / Acervo do Centro Histórico',
    fotos: [
      'https://portalpiracuruca.com/wp-content/uploads/2026/08/guela1.jpg',
      'https://portalpiracuruca.com/wp-content/uploads/2026/08/guela2.jpg',
      'https://portalpiracuruca.com/wp-content/uploads/2026/08/guela3.jpg'
    ]
  },
  81254: {
    nome: 'Povoado Saco dos Polidórios e Trilhas Ecológicas',
    creditos_foto: 'Portal Piracuruca / Comunidade Saco dos Polidórios',
    fotos: [
      'https://portalpiracuruca.com/wp-content/uploads/2026/02/rsmoprin.jpg',
      'https://portalpiracuruca.com/wp-content/uploads/2026/02/matros01.jpg',
      'https://portalpiracuruca.com/wp-content/uploads/2026/02/DJI_0226.jpg'
    ]
  },
  81261: {
    nome: 'Espaço Cultural do Reisado e Arena dos Reis',
    creditos_foto: 'Prefeitura Municipal de Boa Hora / Secretaria de Cultura',
    fotos: [
      'https://boahora.pi.gov.br/wp-content/uploads/2025/12/Reisado-2026.png',
      'https://boahora.pi.gov.br/wp-content/uploads/2025/12/Reisado-2025-Prepare-se.jpeg',
      'https://boahora.pi.gov.br/wp-content/uploads/2025/07/Cultura-Boa-Hora-Valorizacao-scaled.jpg'
    ]
  },
  81268: {
    nome: 'Igreja Matriz de São Pedro e Praça Central',
    creditos_foto: 'Acervo Comunitário / Wikimedia Commons / Prefeitura de Boa Hora',
    fotos: [
      'https://upload.wikimedia.org/wikipedia/commons/7/7c/Igreja_Matriz_de_Boa_Hora_Piau%C3%AD_em_dezembro_de_2018.JPG',
      'https://upload.wikimedia.org/wikipedia/commons/f/f3/Igreja_Matriz_de_Boa_Hora.JPG',
      'https://boahora.pi.gov.br/wp-content/uploads/2026/05/festa-encerramento-1-831x1024.jpeg'
    ]
  },
  81275: {
    nome: 'Rota dos Engenhos Tradicionais e Produção de Rapadura',
    creditos_foto: 'Cooperativa dos Produtores de Boa Hora / Acervo Piauí',
    fotos: [
      'https://upload.wikimedia.org/wikipedia/commons/3/34/Rapadura_de_Boa_Hora-PI.JPG',
      'https://boahora.pi.gov.br/wp-content/uploads/2026/07/WhatsApp-Image-2026-07-15-at-10.51.10.jpeg',
      'https://boahora.pi.gov.br/wp-content/uploads/2026/07/WhatsApp-Image-2026-07-15-at-10.51.11-3.jpeg'
    ]
  },
  81282: {
    nome: 'Biblioteca Pública e Memorial Cultural de Boa Hora',
    creditos_foto: 'Acervo Municipal / Wikimedia Commons / Antonio Filho Piauiense',
    fotos: [
      'https://upload.wikimedia.org/wikipedia/commons/5/58/Biblioteca_Municipal_de_Boa_Hora_Piau%C3%AD.JPG',
      'https://upload.wikimedia.org/wikipedia/commons/f/f8/Biblioteca_de_Boa_Hora_Piau%C3%AD.JPG',
      'https://upload.wikimedia.org/wikipedia/commons/9/94/Rua_de_BH_Piau%C3%AD.JPG'
    ]
  },
  81289: {
    nome: 'Igreja Matriz de Nossa Senhora da Conceição e Praça Monsenhor Boson',
    creditos_foto: 'Wikimedia Commons / Prefeitura Municipal de Barras',
    fotos: [
      'https://upload.wikimedia.org/wikipedia/commons/1/10/Igreja_Matriz_de_Barras_Piau%C3%AD..jpg',
      'https://www.barras.pi.gov.br/wp-content/uploads/2024/11/praca.jpg',
      'https://www.barras.pi.gov.br/wp-content/uploads/2024/06/praca.jpg'
    ]
  },
  81296: {
    nome: 'Orla do Rio Marataoan e Parque Fluvial',
    creditos_foto: 'Portal Longah / Acervo de Barras',
    fotos: [
      'https://longah.com/envios/2025/12/22/c6cd46e41d5f5f4e7bbe0258d9239edf3bd833ed.webp',
      'https://longah.com/envios/2025/12/22/ac9abecbeffb84c61ab3f7344e7a4c392db23c64.webp',
      'https://longah.com/envios/2025/12/22/b4d3c3d84d900883fda26fe444b9e41579dbae0c.webp'
    ]
  },
  81303: {
    nome: 'Circuito de Turismo Rural e Ecoturismo dos Morros',
    creditos_foto: 'Secretaria de Turismo e Desenvolvimento Rural de Barras / Longah',
    fotos: [
      'https://longah.com/envios/2026/04/21/dbde0ec981b22ffc31332ad794f096dc6f95d59a.webp',
      'https://longah.com/envios/2026/04/21/f4dd701ff1c051666a8c2f934887af49db55f48b.webp',
      'https://longah.com/envios/2026/04/21/cc63c7b4efabe30a8c068486dfdcfad9affc0283.webp'
    ]
  },
  81310: {
    nome: 'Centro Histórico e Memória Barrense',
    creditos_foto: 'Academia de Letras / Wikimedia Commons / Acervo Histórico de Barras',
    fotos: [
      'https://upload.wikimedia.org/wikipedia/commons/7/7e/Miniatura_de_Barras_no_Piau%C3%AD_2.jpg',
      'https://upload.wikimedia.org/wikipedia/commons/f/fe/Miniatura_de_Barras_no_Piau%C3%AD.jpg',
      'https://upload.wikimedia.org/wikipedia/commons/c/cf/Onibus_do_General_-_Barras_-_PI..jpg'
    ]
  }
});
